/* istanbul ignore file */
import { useKernelApi } from 'infrastructure/api';
import accessLogValidation from 'domain/people/employee/AccessLog/accessLogValidation';
import { useDateTimeService } from 'framework/utils';

import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';

export const READ_ACCESS_LOG = 'READ_ACCESS_LOG';
/**
 * Employee access log service.
 */
const useAccessLogService = () => {
  const employeeId = useEmployeeId();
  const getValidationSchema = () => Promise.resolve(accessLogValidation);
  const { sendGetRequest } = useKernelApi();
  const { formatDateForAPI } = useDateTimeService();

  const requestLogCsv = (textDateFrom: any, textDateTo: any) => {
    const apiDateFrom = formatDateForAPI(textDateFrom, 'start');
    const apiDateTo = formatDateForAPI(textDateTo, 'end');
    return sendGetRequest(`/employees/${employeeId}/candidateaccesslog?dateFrom=${apiDateFrom}&dateTo=${apiDateTo}`);
  };

  return {
    getValidationSchema,
    requestLogCsv,
  };
};

export default useAccessLogService;
